import React from 'react'
import { inject,observer } from 'mobx-react'
import Divider from 'material-ui/Divider'
import Grid from 'material-ui/Grid'
import { withStyles } from 'material-ui/styles'
import classNames from 'classnames'
import Typography from 'material-ui/Typography'
import T from 'i18n-react'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Reboot from 'material-ui/Reboot'

import IMAGE_LEHRPLAN from '../lehrplan.png'
import IMAGE_WELCOMEPAGE from '../welcomepage.png'
import IMAGE_USER from '../user.png'
import IMAGE_THEMING from '../theming.png'
import IMAGE_SEARCH from '../suche.png'
import IMAGE_SHARE from '../share.png'
import IMAGE_PUBLISH from '../publish.png'
import IMAGE_PAPER from '../paper.png'
import IMAGE_CONTENT from '../inhalte.png'
import IMAGE_NOTIFICATIONS from '../inbox.png'
import IMAGE_COLLECT from '../collect.png'
import IMAGE_LINKCHECKER from '../deadlinks.png'


@observer
class AboutSoftware extends React.Component {
  render () {
    const { classes } = this.props
    return (
     <div className={classNames("width-100p","height-100p",classes.root)}>
      <Reboot />

      <Grid container className={classNames(classes.content,"aboutsoftware")} spacing={0} >

       <Grid item xs={12} sm={12} md={12} lg={12}>
        <div className={classes.head}>
         <Typography component="p" type="display3"> {T.translate("aboutsoftware.title")} </Typography>
         <Typography component="p" type="title" className={classes.general}>
          {T.translate("aboutsoftware.general")}
         </Typography>
        </div>
       </Grid>

       <Divider className={classes.divider} />

       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classNames(classes.imageContainer,classes.rotateLeft)}>
         <img
          src={IMAGE_LEHRPLAN}
          alt=""
          className={classNames(classes.image,classes.boxShadowRight)}
         />
        </div>
       </Grid>
       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classes.textContainer}>
         <Typography component="h2" type="display1" className={classes.sectionTitle}>
          {T.translate("aboutsoftware.curriculum")}
         </Typography>
         <Typography component="p" type="body2">
          {T.translate("aboutsoftware.curriculumDescription")}
         </Typography>
        </div>
       </Grid>

       <Divider className={classes.divider} />

       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classes.textContainer}>
         <Typography component="h2" type="display1" className={classes.sectionTitle}>
          {T.translate("aboutsoftware.content")}
         </Typography>
         <Typography component="p" type="body2"> {T.translate("aboutsoftware.contentDescription")} </Typography>
         <div className={classes.bonus}> {T.translate("meta.bonus")} </div>
         <Typography component="p" type="body2">
          {T.translate("aboutsoftware.contentBonus")}
         </Typography>
        </div>
       </Grid>
       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classNames(classes.imageContainer,classes.rotateRight)}>
         <img
          src={IMAGE_CONTENT}
          alt=""
          className={classNames(classes.image,classes.boxShadowLeft)}
         />
        </div>
       </Grid>

       <Divider className={classes.divider} />

       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classNames(classes.imageContainer,classes.rotateLeft)}>
         <img
          src={IMAGE_SEARCH}
          alt=""
          className={classNames(classes.image,classes.boxShadowRight)}
         />
        </div>
       </Grid>
       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classes.textContainer}>
         <Typography component="h2" type="display1" className={classes.sectionTitle}>
          {T.translate("aboutsoftware.search")}
         </Typography>
         <Typography component="p" type="body2">
          {T.translate("aboutsoftware.searchDescription")}
         </Typography>
        </div>
       </Grid>

       <Divider className={classes.divider} />

       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classes.textContainer}>
         <Typography component="h2" type="display1" className={classes.sectionTitle}>
          {T.translate("aboutsoftware.collection")}
         </Typography>
         <Typography component="p" type="body2">
          {T.translate("aboutsoftware.collectionDescription")}
         </Typography>
        </div>
       </Grid>
       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classNames(classes.imageContainer,classes.rotateRight)}>
         <img
          src={IMAGE_COLLECT}
          alt=""
          className={classNames(classes.image,classes.boxShadowLeft)}
         />
        </div>
       </Grid>

       <Divider className={classes.divider} />

       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classNames(classes.imageContainer,classes.rotateLeft)}>
         <img
          src={IMAGE_SHARE}
          alt=""
          className={classNames(classes.image,classes.boxShadowRight)}
         />
        </div>
       </Grid>
       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classes.textContainer}>
         <Typography component="h2" type="display1" className={classes.sectionTitle}>
          {T.translate("aboutsoftware.share")}
         </Typography>
         <Typography component="p" type="body2">
          {T.translate("aboutsoftware.shareDescription")}
         </Typography>
        </div>
       </Grid>

       <Divider className={classes.divider} />

       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classes.textContainer}>
         <Typography component="h2" type="display1" className={classes.sectionTitle}>
          {T.translate("aboutsoftware.paper")}
         </Typography>
         <Typography component="p" type="body2">
          {T.translate("aboutsoftware.paperDescription")}
         </Typography>
        </div>
       </Grid>
       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classNames(classes.imageContainer,classes.rotateRight)}>
         <img
          src={IMAGE_PAPER}
          alt=""
          className={classNames(classes.image,classes.boxShadowLeft)}
         />
        </div>
       </Grid>

       <Divider className={classes.divider} />

       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classNames(classes.imageContainer,classes.rotateLeft)}>
         <img
          src={IMAGE_PUBLISH}
          alt=""
          className={classNames(classes.image,classes.boxShadowRight)}
         />
        </div>
       </Grid>
       <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className={classes.textContainer}>
         <Typography component="h2" type="display1" className={classes.sectionTitle}>
          {T.translate("aboutsoftware.publish")}
         </Typography>
         <Typography component="p" type="body2">
          {T.translate("aboutsoftware.publishDescription")}
         </Typography>
        </div>
       </Grid>

      </Grid>

      <section className={classNames(classes.sectionPurple,classes.section)}>
       <Typography component="p" type="display2" style={{color:'#fff'}}>
        {T.translate("aboutsoftware.admin")}
       </Typography>
       <Typography component="p" type="headline" style={{color:'#fff'}}>
        {T.translate("aboutsoftware.adminContent")}
       </Typography>
      </section>

      <Grid container className={classNames(classes.content,"aboutsoftware")} spacing={0} >

        <Grid item xs={12} sm={6} md={6} lg={6}>
         <div className={classes.textContainer}>
          <Typography component="h2" type="display1" className={classes.sectionTitle}>
           {T.translate("aboutsoftware.user")}
          </Typography>
          <Typography component="p" type="body2">
           {T.translate("aboutsoftware.userDescription")}
          </Typography>
         </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
         <div className={classNames(classes.imageContainer,classes.rotateRight)}>
          <img
           src={IMAGE_USER}
           alt=""
           className={classNames(classes.image,classes.boxShadowLeft)}
          />
         </div>
        </Grid>

        <Divider className={classes.divider} />

        <Grid item xs={12} sm={6} md={6} lg={6}>
         <div className={classNames(classes.imageContainer,classes.rotateLeft)}>
          <img
           src={IMAGE_NOTIFICATIONS}
           alt=""
           className={classNames(classes.image,classes.boxShadowRight)}
          />
         </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
         <div className={classes.textContainer}>
          <Typography component="h2" type="display1" className={classes.sectionTitle}>
           {T.translate("aboutsoftware.notifications")}
          </Typography>
          <Typography component="p" type="body2">
           {T.translate("aboutsoftware.notificationsDescription")}
          </Typography>
         </div>
        </Grid>

        <Divider className={classes.divider} />

        <Grid item xs={12} sm={6} md={6} lg={6}>
         <div className={classes.textContainer}>
          <Typography component="h2" type="display1" className={classes.sectionTitle}>
           {T.translate("aboutsoftware.config")}
          </Typography>
          <Typography component="p" type="body2">
           {T.translate("aboutsoftware.configDescription")}
          </Typography>
         </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
         <div className={classNames(classes.imageContainer,classes.rotateRight)}>
          <img
           src={IMAGE_THEMING}
           alt=""
           className={classNames(classes.image,classes.boxShadowLeft)}
          />
         </div>
        </Grid>

        <Divider className={classes.divider} />

        <Grid item xs={12} sm={6} md={6} lg={6}>
         <div className={classNames(classes.imageContainer,classes.rotateLeft)}>
          <img
           src={IMAGE_WELCOMEPAGE}
           alt=""
           className={classNames(classes.image,classes.boxShadowRight)}
          />
         </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
         <div className={classes.textContainer}>
          <Typography component="h2" type="display1" className={classes.sectionTitle}>
           {T.translate("aboutsoftware.welcomepage")}
          </Typography>
          <Typography component="p" type="body2">
           {T.translate("aboutsoftware.welcomepageDescription")}
          </Typography>
         </div>
        </Grid>

        <Divider className={classes.divider} />

        <Grid item xs={12} sm={6} md={6} lg={6}>
         <div className={classes.textContainer}>
          <Typography component="h2" type="display1" className={classes.sectionTitle}>
           {T.translate("aboutsoftware.linkchecker")}
          </Typography>
          <Typography component="p" type="body2">
           {T.translate("aboutsoftware.linkcheckerDescription")}
          </Typography>
         </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
         <div className={classNames(classes.imageContainer,classes.rotateRight)}>
          <img
           src={IMAGE_LINKCHECKER}
           alt=""
           className={classNames(classes.image,classes.boxShadowLeft)}
          />
         </div>
        </Grid>

      </Grid>


     </div>
    )
  }
}


const styles = theme => ({
 root: {
  flexGrow: 1,
 },
 head:{
   display:'flex',
   'justify-content':'center',
   'align-items':'center',
   'text-align':'center',
   'flex-flow':'column'
 },
 bonus:{
   'margin-top':20,
   'font-weight':'bold'
 },
 section:{
   height:200,
   width:'100%',
   'margin-top':50,
   'margin-bottom':50,
   display:'flex',
   'justify-content':'center',
   'align-items':'center',
   'flex-flow':'column'
 },
 sectionPurple:{
   background:'#9C27B0'
 },
 sectionTeal:{
   background:'#009688'
 },
 general:{
   padding:15
 },
 sectionTitle:{
   'margin-bottom':30
 },
 divider:{
   width:'80%',
   margin:'0 auto',
   'margin-top':50,
   'margin-bottom':50
 },
 rotateLeft:{
   transform:'rotate(1deg)'
 },
 rotateRight:{
   transform:'rotate(-1deg)'
 },
 imageContainer:{
   'background-position':'center center',
   'background-size':'contain',
   'background-repeat':'no-repeat',
   padding:30
 },
 textContainer:{
   padding:15,
   display:'flex',
   height:'100%',
   'justify-content':'center',
   'flex-flow':'column'
 },
 image:{
   width:'100%'
 },
 appFrame: {
   position: 'relative',
   display: 'flex',
   width: '100%',
 },
 appBar: {
   position: 'absolute',
   transition: theme.transitions.create(['margin', 'width'], {
     easing: theme.transitions.easing.sharp,
     duration: theme.transitions.duration.leavingScreen,
   }),
 },
 content:{
   marginTop: 56,
   [theme.breakpoints.up('sm')]: {
     marginTop: 64,
   },
 },
 flex:{
   flex:1
 },
 boxShadowRight:{
  '-webkit-box-shadow': '5px 10px 10px 1px rgba(196,196,196,1)',
  '-moz-box-shadow': '5px 10px 10px 1px rgba(196,196,196,1)',
  'box-shadow': '5px 10px 10px 1px rgba(196,196,196,1)'
 },
 boxShadowLeft:{
  '-webkit-box-shadow': '-5px 10px 10px 1px rgba(196,196,196,1)',
  '-moz-box-shadow': '-5px 10px 10px 1px rgba(196,196,196,1)',
  'box-shadow': '-5px 10px 10px 1px rgba(196,196,196,1)'
 }
})



export default withStyles(styles)(AboutSoftware)



// WEBPACK FOOTER //
// ./src/components/aboutsoftware.js